export class Login {

  constructor(
    public username: string,
    public password: string,
    public passwordChange: boolean,
    public session: string,
    public confirmPassword: string
  ) { }

}

export class ForgotPassword {

  constructor(
    public username: string,
    public password: string,
    public forgotPassword: boolean,
    public resetPassword: boolean,
    public confirmForgotPassword: boolean,
    public confirmationCode: string,
    public confirmPassword: string
  ) { }

}

export class ChangePassword {

  constructor(
    public username: string,
    public password: string,
    public confirmPassword: string
  ) { }

}
